import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'pme-payment-methods',
    templateUrl: './payment-methods.component.html',
    styleUrls: ['./payment-methods.component.scss'],
    standalone: false
})
export class PaymentMethodsComponent implements OnInit {

  paymentMethodsImages = [
    "mastercard.png",
    "visa.png",
    "elo.png",
    "hipercard.png",
    "american-express.png",
    "diners-club.png",
    "discover.png",
    "boleto.png",
    "pix.png",
  ];


  constructor() { }

  ngOnInit(): void {
  }

}
